import { useMemo } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Column } from 'src/components/custom_components/CustomTable/CustomTable';

import { getColumnKey } from 'src/models/ColumnConfiguration.model';
import { I18NextNS } from 'src/models/Language.model';

export interface ColumnConfigurationProps<T> {
  columns: Column<T>[];
  visibleColumns: Record<string, boolean>;
  onToggleColumn: (key: string) => void;
}

export function ColumnConfiguration<T>({
  columns,
  visibleColumns,
  onToggleColumn,
}: ColumnConfigurationProps<T>) {
  const { t } = useTranslation(I18NextNS.COMMON);

  const displayedColumns = useMemo(
    () => columns.filter((column) => visibleColumns[getColumnKey(column)]),
    [columns, visibleColumns],
  );

  return (
    <div className="d-flex justify-content-end">
      <Dropdown autoClose="outside">
        <Dropdown.Toggle variant="light" className="px-3 py-2">
          {t('table.Table Configuration')} ({displayedColumns.length}/
          {columns.length})
        </Dropdown.Toggle>

        <Dropdown.Menu className="p-2" align="start">
          {columns.map((column) => (
            <div
              key={getColumnKey(column)}
              className="d-flex justify-content-between align-items-center mb-2"
              style={{ minWidth: 200 }}
            >
              <div>{column.title}</div>
              <Form.Switch
                id={getColumnKey(column)}
                data-test={`column-toggle-${getColumnKey(column)}`}
                checked={visibleColumns[getColumnKey(column)]}
                onChange={() => onToggleColumn(getColumnKey(column))}
              />
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default ColumnConfiguration;
